import _ from 'lodash';
import React, { Dispatch, SetStateAction, useEffect} from 'react';
import {
  Icon,
  Segment,
  Table,
  Pagination,
  Button,
  Checkbox,
  Loader,
  Dropdown,
  DropdownProps,
} from 'semantic-ui-react';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/store';
import ReportsModal from '../TableReports/ReportsModal';
import { Link, useNavigate } from 'react-router-dom';
import DashboardReceivingDeliveryForm from '../Dashboard/SubForms/DashboardReceivingDeliveryForm';
import DeleteConfirmation from '../../app/common/modals/DeleteConfirmation';
import VaultMasterForm from '../VaultMaster/VaultMasterForm';
import ShelfRackMasterForm from '../ShelfRackMaster/ShelfRackMasterForm';
import DeviceMasterForm from '../DeviceMaster/DeviceMasterForm';
import DepartmentMasterForm from '../DepartmentMaster/DepartmentMasterForm';
import CustomerMasterForm from '../CustomerMaster/CustomerMasterForm';
import WorkLevelMasterForm from '../WorkLevelMaster/WorkLevelMasterForm';
import '../../app/common/MediaQuery/responsive-table-style.css';
import SearchInputData from './SearchInputData';
import SortData from './SortData';
import DynamicTableCSVReport from './DynamicTableCSVReport';
import LoadingComponent, { LoadingComponent3 } from './../../app/layout/LoadingComponent';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import agent from '../../app/api/agent';
import HFCTaskModal from './HFCTaskModal';
import { initialElement, workflowSubTask } from '../../app/api/types';
import ReceiptModal from './ReceiptModal';
import { historyInitialState } from '../../app/models/history';
import { toast } from 'react-toastify';
import LabelModal from './LabelModal';
import LtoLabelModal from './LtoLabelModal';

interface Props {
  data: any;
  name: any;
  actiontype: string;
  pageFunc: any; //func
  pageNumData: number;
  searchFuncData: any; //func
  setPageNumber?: Dispatch<SetStateAction<number>>;
  classNameForQuickScan?: any;
  checkBoxClickedInventoryandQuickScan?: any;
  loading?: boolean;
  isdisabled?: boolean;
  pageSize?:number;
  ReadMailCheckboxFunc?:any;
  EmailsearchHandler?:(obj:any,page:number,condition:string)=>void;
  sortHandler?:any;
  openTagModal?:() => void
  filters?:any
}
/* Sort - End*/
function DynamicTableComponent({
  data,
  name,
  actiontype,
  pageFunc,
  pageNumData,
  searchFuncData,
  setPageNumber,
  classNameForQuickScan,
  checkBoxClickedInventoryandQuickScan,
  loading,
  isdisabled = false,
  pageSize,
  ReadMailCheckboxFunc,
  EmailsearchHandler,
  sortHandler,
  openTagModal,
  filters
}: Props) {
  const {
    emailStore,
    dashboardStore,
    ElementStore,
    receivingdeliveryStore,
    modalStore,
    mediaAssetStore,
    rejectionStore,
    vaultStore,
    ShelfRackStore,
    DeviceStore,
    departmentStore,
    customerStore,
    WorkLevelStore,
    userStore,
    activityStore,
    reportStore,
    commonStore,
    QuickScanStore,
    userStore: { user },
    CRMStore,
    TrackingReportStore,
    metaDataStore
  } = useStore();
  const[isModal, SetIsModal]= useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [ltoModal, setLtoModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState<Map<number, string>>(new Map());
  const[shippingPrep ,setShippingPrep] = useState<workflowSubTask>({
    subTaskId: "",
    subtaskIndex: 0,
    subTaskName: "",
    subTaskDateTime: "",
    autoRejectTo: null,
    isFinish: false,
    isActive: false,
    isDeleted: false,
    isCurrentSubtask: false,
    tATTime: 0,
    startSTDate: "",
    endSTDate: "",
    subTaskstatus: 0,
    status: 0,
    recVersion: "",
    templateSubtaskId: "",
    actionerName: null,
    elements: [initialElement],
    files: [],
    communication: [],
    api: [],
  });
  const [title, setTitle] = useState<string>('');
  const [rowData, setRowData] = useState<any>({});

  const[selectedId, setSelectedId]= useState<string>('')
  const[selected, setSelected]=useState<any>({})

  const rowsOption=[
    {
    key: 1,
    text: '5',
    value: 5
    },
    {
      key: 2,
      text: '25',
      value: 25
    },
    {
      key: 3,
      text: '50',
      value: 50
    },
    {
      key: 4,
      text:'75',
      value: 75
    },
    {
      key: 5,
      text: '100',
      value: 100
    }
  ]


  const {
    quickScanshowButton,
    QuickscanAsstableClicked,
    WithoutbarcodeInvetoryData,
  } = QuickScanStore;
  const { loadVault } = vaultStore;
  const history = useNavigate();
  const tableName = name;

  const [postsPerPage] = useState<any>(
    tableName === 'ReportsTable' ||
      tableName === 'FilmFestivalReport' ||
      tableName === 'AllocateUser'  || 
      CRMStore.SubtaskGroupDetails.some((e)=> `CRM ${e.subtask}` === tableName) || tableName === 'CRM Authorization' ||
      tableName === 'CRM InWard'|| tableName === 'CRM OutWard'  || tableName === 'IT Asset List'
      ? 10
      : tableName === 'QuickScan' ||
          (tableName === 'AssetTable' && user?.customerName === 'Restoration') || (tableName === 'SmartTracker' && ['Operator','Quality Check'].includes(user?.roleName.trim() || '') && user?.customerName === 'NFAIReport')
          || tableName === 'Reel Smarttracker'
        ? 20
        :(tableName ==="AssetTable" && commonStore.hfcCustomerChanges)
        ? activityStore.HfcSelectedRow
        :tableName === 'CrmAssetTrack' ? 10 
        : 5,
  );

  const isNormal = Object.keys(dashboardStore.dashboard.searchfilterparams).length === 0;
  const assetCount = isNormal ? CRMStore.assetTracking.count : CRMStore.assetTracking.searchCount

  let tableHeads: any;
  const countData =
    tableName === 'AssetTable' && userStore.user?.customerName !== 'LVPCMS'
      ? dashboardStore.dashboard.inventoryCount2
      : tableName === 'AssetTable' && userStore.user?.customerName === 'LVPCMS'
        ? dashboardStore.dashboard.inventoryCount2
        : tableName === 'QuickScan' && (userStore.user?.customerName === 'HFC Media Services' || 'Demo Site')
        ? dashboardStore.dashboard.inventoryCount2
        : tableName === 'HFCMoveToVault' && (userStore.user?.customerName === 'HFC Media Services'|| 'Demo Site')
        ? dashboardStore.dashboard.VaultCount
        : tableName === 'TagTable'
          ? dashboardStore.dashboard.tagCount
          : tableName === 'AllocateUser'
            ? dashboardStore.dashboard.inventoryCount2 
            : tableName === 'HFCScan'
            ? dashboardStore.dashboard.ScanCount//call the count api
            : tableName === 'HFCShipper' && dashboardStore.dashboard.L2CardValueInventory === "Receiving" && dashboardStore.dashboard.valueForL3Orders === " "
            ? dashboardStore.dashboard.inventoryCount2
            : tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Shipper"
            ?dashboardStore.dashboard.shipperCount
            : tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Returning Services"
            ?dashboardStore.dashboard.HFCReturnCount
            : tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Assign Task to Personnal"
            ?dashboardStore.dashboard.AssignCount
            : tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Pull"
            ?dashboardStore.dashboard.pullCount
            : tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Shipping Prep"
            ?dashboardStore.dashboard.shippingPrepCount
            : tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Shipping"
            ?dashboardStore.dashboard.shippingCount
            : tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Services"
            ?dashboardStore.dashboard.HFCServiceCount
            : tableName === 'QuickScan'
              ? dashboardStore.dashboard.inventoryCount2 //call the count api
              : tableName === 'CreateOrderTable'
                ? dashboardStore.dashboard.CreateOrderCount
                : tableName === 'ReceivingTable'
                  ? dashboardStore.dashboard.receivingsCount
                  : tableName === 'EmailTable'
                    ? emailStore.emailMessageDetails.count
                    : tableName === 'AlertsTable'
                      ? emailStore.emailAlertDetails.count
                      : tableName === 'TagTable'
                        ? dashboardStore.dashboard.tagCount
                        : tableName === 'CreateOrderTable'
                          ? dashboardStore.dashboard.CreateOrderCount
                          : tableName === 'ReportsTable'
                            ? dashboardStore.dashboard.inventoryCount2
                            : tableName === 'FilmFestivalReport'
                              ? dashboardStore.dashboard.FFTableCount
                              : tableName === 'prodPlanTable'
                                ? dashboardStore.dashboard.prodPlanTableLength
                                : tableName === 'viewHistoryTable'
                                  ? activityStore.historyCount
                                  : tableName === 'viewTemplateTable'
                                    ? activityStore.viewTemplateCount
                                    : tableName === 'NewAssetAdded'
                                      ? activityStore.inventoryReports
                                          .newAssetAdded.count
                                      : tableName ===
                                          'CurrentMonthAssetCANMovement'
                                        ? activityStore.inventoryReports
                                            .currentMonthAssetCANMovement.count
                                        : tableName ===
                                            'PendingReturnsFromBorrowers'
                                          ? activityStore.inventoryReports
                                              .pendingReturnsFromBorrowers.count
                                          : tableName ===
                                              'AssetsScheduledForCleaning'
                                            ? activityStore.inventoryReports
                                                .assetsScheduledForCleaning
                                                .count
                                            : tableName === 'AssetsCleaned'
                                              ? activityStore.inventoryReports
                                                  .assetsCleaned.count
                                              : tableName ===
                                                  'DigitalizationPriority'
                                                ? activityStore.inventoryReports
                                                    .digitalizationPriority
                                                    .count
                                                : // inward
                                                  tableName === 'Verify'
                                                  ? activityStore.inward.verify
                                                      .count
                                                  : tableName === 'Approve'
                                                    ? activityStore.inward
                                                        .approve.count
                                                    : tableName ===
                                                        'MoveToVault'
                                                      ? activityStore.inward
                                                          .moveToVault.count
                                                      : tableName ===
                                                          'PickerAssign'
                                                        ? activityStore.inward
                                                            .PickerAssign.count
                                                        : // outward
                                                          tableName ===
                                                            'Unvault'
                                                          ? activityStore
                                                              .outward.unvault
                                                              .count
                                                          : tableName ===
                                                              'VerifyOutward'
                                                            ? activityStore
                                                                .outward
                                                                .verifyOutward
                                                                .count
                                                            : tableName ===
                                                                'ApproveOutward'
                                                              ? activityStore
                                                                  .outward
                                                                  .approveOutward
                                                                  .count
                                                              : tableName ===
                                                                  'AssignPickerOutward'
                                                                ? activityStore
                                                                    .outward
                                                                    .assignPickerOutward
                                                                    .count
                                                                : tableName ===
                                                                    'Move'
                                                                  ? activityStore
                                                                      .outward
                                                                      .move
                                                                      .count
                                                                  : tableName ===
                                                                      'Package'
                                                                    ? activityStore
                                                                        .outward
                                                                        .package
                                                                        .count
                                                                    : tableName ===
                                                                        'Billing'
                                                                      ? activityStore
                                                                          .outward
                                                                          .billing
                                                                          .count
                                                                      : tableName ===
                                                                          'TagOrder'
                                                                        ? activityStore
                                                                            .outward
                                                                            .tagOrder
                                                                            .count
                                                                        : // view item group
                                                                          tableName ===
                                                                            'WorkLevelTable'
                                                                          ? WorkLevelStore
                                                                              .viewItemGroups
                                                                              .count
                                                                          : tableName ===
                                                                              'ReadMail'
                                                                            ? pageSize
                                                                            : tableName ===
                                                                                'UnreadMail'
                                                                              ? pageSize
                                                                              : CRMStore.SubtaskGroupDetails.some((e)=> `CRM ${e.subtask}` === tableName)
                                                                                ? CRMStore.count
                                                                                : tableName === 'CRM Authorization'
                                                                                  ? CRMStore.authorizationTable.count
                                                                                  : tableName === 'CRM InWard'|| tableName === 'CRM OutWard'
                                                                                  ? CRMStore.logisticsTable.count
                                                                                  ? tableName === 'Reel Smarttracker'
                                                                                  : TrackingReportStore.reelSmarttracker.count
                                                                                  : tableName === 'IT Asset List' 
                                                                                  ? CRMStore.itAssetTableDetails.count
                                                                                  :tableName === 'CrmAssetTrack' ? assetCount
                                                                                  : tableName === 'NFAIRestorationDashboard' ? 
                                                                                  metaDataStore.NfaiRestorationDashboardInfo.count
                                                                              : data.length;


  if (
    localStorage.getItem(tableName) !== undefined &&
    localStorage.getItem(tableName) !== null
  ) {
    tableHeads = localStorage.getItem(tableName)!.split(',');
  } else {
    localStorage.setItem(tableName, '');
  }
  // const tableHeads = tableHead;

  const handleApprove = async(id:string, data:any)=>{
    await agent.HFC.HFCPullApprove(id, true)
    const payload =  {
      ...historyInitialState,
      itemId: data.asset_ID,
      status: `${userStore.user?.displayName} has accepted the pull request for the asset "${data.title}"`,
      dateTime: new Date().toISOString(),
      trackerFromTime: new Date().toISOString(),
    }
    await agent.HFC.HFCaddHistory(payload)
    dashboardStore.dashboard.valueForL3Orders = "Shipping Prep"
    await activityStore.HFCPullloadActivitiesPagination(1,"", 5,[])
  }

  const handlePostPerPage = async (e: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    const { value } = data;
    const userId = userStore?.user!.id;
    if(filters.length > 0){
      const filterValues = filters
        .filter((filter:any) => 
          filter.column.trim() !== '' &&
          filter.operator.trim() !== '' &&
          filter.value.trim() !== ''
        ) // Only include filters with non-empty column, operator, and value
        .map((filter:any) => ({
          colName: filter.column,
          filterType: filter.operator,
          filterValue: filter.value
        }));
      await activityStore.HFCloadActivitiesPagination(1, userId, value as number, filterValues);
    }
    activityStore.HfcSelectedRow = value as number
  };
  
  const handleReject = async(id:string)=>{
    await agent.HFC.HFCPullApprove(id, false)
    const payload =  {
      ...historyInitialState,
      itemId: data.asset_ID,
      status: `${userStore.user?.displayName} has rejected the pull request for the asset "${data.title}"`,
      dateTime: new Date().toISOString(),
      trackerFromTime: new Date().toISOString(),
    }
    await agent.HFC.HFCaddHistory(payload)
    dashboardStore.dashboard.valueForL3Orders = "Pull"
    await activityStore.HFCPullloadActivitiesPagination(1,"", 5,[])

  }

  function exampleReducer(state: any, action: any) {
    switch (action.type) {
      case 'CHANGE_SORT':
        if (state.column === action.column) {
          return {
            ...state,
            // state.tabledata.slice().reverse()
            tabledata: state.tabledata.slice().reverse(),
            direction:
              state.direction === 'ascending' ? 'descending' : 'ascending',
          };
        }
        return {
          column: action.column,
          // _.sortBy(state.tabledata, [action.column])
          tabledata: _.sortBy(state.tabledata, [action.column]),
          direction: 'ascending',
          currentPages: 1,
        };
      case 'UPDATE_DATA':
        return {
          column: action.column,
          tabledata: data,
          direction: null,
          currentPages: 1,
        };

      default:
        throw new Error();
    }
  }
  const [state, dispatch] = React.useReducer(exampleReducer, {
    column: null,
    tabledata: data,
    direction: null,
    currentPages: 1,
  });
  const { tabledata } = state;

    const handleSelectAll = () => {
    const allSelected = tabledata.every((item:any) => selectedItems.has(item.id));
    setSelectedItems(prev => {
      const newMap = new Map(prev);
      tabledata.forEach((item: any) => {
        if (allSelected) {
          newMap.delete(item.id);
        } else {
          newMap.set(item.id, item.title ?? '');
        }
      });
      return newMap;
    });
  };

const handleSelect = (id: number, title: string) => {
  setSelectedItems((prev) => {
    const newMap = new Map(prev);
    if (newMap.has(id)) {
      newMap.delete(id);
    } else {
      newMap.set(id, title);
    }
    return newMap;
  });
};



  const isAllSelected: boolean = tabledata.length > 0 && tabledata.every((item:any) => selectedItems.has(item.id));

  

  useEffect(() => {
    // dipatch is called after data is updated via props
    dispatch({ type: 'UPDATE_DATA' });
  }, [data]);

 

  // useEffect(()=>{
  //   reportStore.isCheckAll.checked = false;
  //   reportStore.HFCCheck=false
  // },[])

  // useEffect(() => {
  //   if (tabledata?.length === 0) {
  //     // setpageNumData(1);
  //     setPageNumber && setPageNumber(1)
  //     receivingdeliveryStore.loadReceivingsDeliveriesPagination(1);
  //   }
  //   // eslint-disable-next-line
  // }, [tabledata?.length]);

  // const [currentPage, setCurrentPage] = useState<any>(1);
 
  const [activeRowId, setActiveRowId] = useState<any>(
    dashboardStore.dashboard.rowIdForDynamicTable,
  );
  const [hoverRowId, setHoverRowId] = useState<any>(-1);
  /* Code for Pagination - End*/
  /* Search - Start */

  const handleChange = () => {
    let maxLength = 0;
    let maxObjectIndex = 0;
    for (let i = 0; i <= tabledata.length - 1; i++) {
      if (Object.keys(tabledata[i]).length > maxLength) {
        maxLength = Object.keys(tabledata[i]).length;
        maxObjectIndex = i;
      }
    }
    let setting = Object?.keys(tabledata[maxObjectIndex]);
    if (user?.customerName === 'NFAI') {
      const index = setting.indexOf('physical_sensor_NFC');
      if (index !== -1) {
        setting[index] = 'Asset_id';
      }
    }
    const removeSettingsOption = [
      'deliveryRequestId',
      'isDeleted',
      'isMaster',
      'itemDeliveryRequest',
      'orders',
      'inwards',
      'isActive',
      'isReceiving',
      'isDelivery',
      'itemCreatedBy',
      'assignedUsers',
      'isHost',
      'digitalization_priority',
      'calculated_category',
      'clearedon',
      'isReceivingOrder',
      'number_of_element',
      'elementtypeid',
      'typeid',
    ];
    const removeSettingsOption1 = [
      'deliveryRequestId',
      'isDeleted',
      'isMaster',
      'itemDeliveryRequest',
      'orders',
      'inwards',
      'isActive',
      'isReceiving',
      'isDelivery',
      'itemCreatedBy',
      'assignedUsers',
      'isHost',
      'digitalization_priority',
      'calculated_category',
      'clearedon',
      'isReceivingOrder',
      'number_of_element',
      'physical_location_vault',
      'physical_location_shelf',
      'physical_sensor_barcode',
      'asset_In_Vault',
      'elementtypeid',
      'typeid',
    ];
    if (user?.customerName !== 'CG') {
      setting = setting.filter((s) => !removeSettingsOption.includes(s));
    } else {
      setting = setting.filter((s) => !removeSettingsOption1.includes(s));
    }

    dashboardStore.setTableClicked(
      tabledata.length > 0 ? setting : null,
      tableName,
    );
    dashboardStore.reportsConfigurationOpen(true);
  };
  /////////////// Edit Function (Receving Delivery )
  const loadEditData = (id: string) => {
    if (tableName === 'ReceivingTable') {
      modalStore.openModal(<DashboardReceivingDeliveryForm />);
      receivingdeliveryStore.loadReceivingDelivery(id);
    } else if (tableName === 'VaultTable') {
      loadVault(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<VaultMasterForm viewPort={false} />);
    } else if (tableName === 'ShelfRackTable') {
      ShelfRackStore.loadshelfRack(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<ShelfRackMasterForm viewPort={false} />);
    } else if (tableName === 'DeviceTable') {
      DeviceStore.loadDevice(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<DeviceMasterForm />);
    } else if (tableName === 'DepartmentTable') {
      departmentStore.loadDepartment(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<DepartmentMasterForm isEdit />);
    } else if (tableName === 'CustomerTable') {
      customerStore.loadCustomer(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<CustomerMasterForm />);
    } else if (tableName === 'WorkLevelTable') {
      WorkLevelStore.loadWorkLevel(id);
      dashboardStore.dashboard.formikClearFormBool = true;
      modalStore.openModal(<WorkLevelMasterForm />);
    }
  };
  //////////////delete the receving delivery,Customer,Dept,Shelf ,Vault Device item group
  const deleteData = (data: any, type: string) => {
    activityStore.imageSrc=[]
    modalStore.openModal(
      <DeleteConfirmation type={type} name={data.title} data={data} />,
    );
  };

//   const createPDF = async (data: any, selectedId: any) => {
//     const doc = new jsPDF({
//         putOnlyUsedFonts: true,
//         orientation: 'portrait',
//     });
//     let xPos = 5;
//     let yPos = 40;
//     const lineSpacing = 5;

//     // Load Helvetica font
//     await doc.addFont('https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/vfs_fonts.js', 'times-new-roman', 'bold');

//     // Set Times New Roman as the default font
//     doc.setFont('times-new-roman');

//     doc?.addImage('https://res.cloudinary.com/drvaemi9t/image/upload/v1683893697/sfjftefmtkiye8bdk4vm.png', 'JPEG', 5, 5, 40, 20);
//     const dateValue = data.date;
//     const datePart = dateValue.split("T")[0];
//     const [year, month, day] = datePart.split("-");
//     const formattedDate = `${month}/${day}/${year}`;
//     // const address = data.address;
//     // var addressParts = address.split(',');
//     // const formattedAddress = addressParts.map((part: string, index: number) => {
//     //     const trimmedPart = part.trim();
//     //     return index === addressParts.length - 1 ? trimmedPart : trimmedPart + ',';
//     // }).join('\n');
//     // const marginSpace = " ".repeat(10); // This will create a string with 10 spaces
//     // const marginSpace1 = " ".repeat(8);
//     // const marginSpace2 = " ".repeat(5);
//     // const marginSpaceFirstLine = " ".repeat(20);
//     // const marginSpaceSecondLine = " ".repeat(35);
//     // const marginSpace3 = " ".repeat(13);

//     doc?.setFontSize(18);
//     doc?.text('Shipping Receipt',150, 10);
//     // doc.line(5, yPos + 5, 200, yPos + 5);
//     // doc?.setFontSize(14);
//     // yPos += 15;
//     // doc?.text('Contact Name: ' + marginSpace + data.contact_Name, xPos + 5, yPos);
//     // doc?.setFontSize(14);
//     // yPos += 10;
//     // doc?.text('Company Name:' + marginSpace1 + data.company_Name, xPos + 5, yPos);
//     // doc?.setFontSize(14);
//     // yPos += 10;
//     // const addressLines = formattedAddress.split('\n');

//     // // Print each line of the address with respective margin space
//     // addressLines.forEach((line: any, index: any) => {
//     //     let marginSpace = index === 0 ? marginSpaceFirstLine : marginSpaceSecondLine;
//     //     let prefix = index === 0 ? 'Address: ' : ''; // Add 'Address:' prefix only to the first line
//     //     doc?.text(prefix + marginSpace + line, xPos + 5, yPos + index * lineSpacing);
//     // });

//     // // Update yPos for next text
//     // yPos += addressLines.length * lineSpacing;
//       doc?.setFontSize(14);
//       doc?.text('Order No:' + 12345678910, 150, 17);
//       doc?.setFontSize(14);
//       doc?.text('Date:' + formattedDate, 150, 22);
//       const headers = ['Shipping Facility', 'Contact Information', 'Delivery To'];
//     yPos = 40; // Initial Y position for table
//     const cellWidth = 65;
//     const cellHeight = 10;
//     const startXPos = 5;
//     const startYPos = yPos;
//     const lineHeight = 5;

//     doc.setDrawColor(0); // Set line color to black
//     doc.setLineWidth(0.1); // Set line width
//     doc.setFontSize(12);
//     headers.forEach((header, index) => {
//         doc.rect(startXPos + index * cellWidth, startYPos, cellWidth, cellHeight); // Draw cell
//         doc.text(header, -5 + index * cellWidth + cellWidth / 2 - (doc.getStringUnitWidth(header) * 0.5), startYPos + cellHeight / 2 + lineHeight / 2); // Center text vertically and horizontally in cell
//     });
//     // doc.line(5, yPos + 5, 200, yPos + 5);
//     // doc?.setFontSize(14);
//     // yPos += 15;
//     // doc?.text('Asset-ID:' + marginSpaceFirstLine + data.asset_ID, xPos + 5, yPos);
//     // data.containerBarCodes.forEach((container: any) => {
//     //     doc?.setFontSize(14);
//     //     yPos += 10;
//     //     doc?.text('Container Barcode:' + marginSpace2 + container.container_Barcode, xPos + 5, yPos);
//     //     container.reel_Barcodes.forEach((reel: any) => {
//     //         doc?.setFontSize(14);
//     //         yPos += 10;
//     //         doc?.text('Reel Barcode: ' + marginSpace3 + reel, xPos + 5, yPos);
//     //     });
//     // });

//     // // Calculate the remaining space on the current page
//     // const remainingSpace = doc.internal.pageSize.height - yPos;

//     // // If there is not enough space for the signature, add a new page
//     // if (remainingSpace < 20) {
//     //     doc.addPage();
//     //     yPos = 40; // Reset yPos for the new page
//     // }

//     // // Place the signature text and image at the bottom of the page
//     // const signatureYPos = doc.internal.pageSize.height - 20;
//     // doc?.text('Signature', xPos + 5, signatureYPos);
//     // doc?.addImage('../../assets/signature.png', 'JPEG', -10, signatureYPos - 5, 60, 20);

//     // Upload PDF file and handle response
//     let subTaskConst: uploadFileType = {
//         id: '',
//         files: [],
//     };
//     let response: any = [];
//     const blobPDF: any = new Blob([doc.output('blob')], {
//         type: 'application/pdf',
//     });
//     response = await agent.Files.uploadFile(blobPDF);
//     Object.assign(response.data, { fileId: uuid() });
//     response.data.id = uuid();
//     response.data.fileName = 'Shipping Receipt';
//     subTaskConst = {
//         id: selectedId,
//         files: [
//             {
//                 ...response.data,
//                 addedOn: new Date(),
//             },
//         ],
//     };
//     await ElementStore.HFCgeneratePdf(subTaskConst);

//     // Download the PDF file
//     const pdfDataUri = doc.output('datauristring');
//     const link = document.createElement('a');
//     link.href = pdfDataUri;
//     link.download = `${response.data.fileName}.pdf`;
//     link.click();
// };




// const invoice = async (data: any, type: string) => {
//   try {
//       const res = await agent.HFC.HFCShippingAsset(data.id);
//       const seleceted = res.data
//       setPrintLoading(true)
//       await createPDF(seleceted, data.id)
//       setPrintLoading(false)
//       activityStore.HFCShippingdeliveryloadActivitiesPagination (1, "",5)
//   } catch (error) {
//       // Handle errors
//       console.error('Error fetching data:', error);
//   }
// };

const openpdfModal = async(data:any)=>{
  SetIsModal(true)
  setSelected(data)
  activityStore.imageSrc=[]
} 

const openLabelModal = async(data:any, tableName:string)=>{
  setOpenModal(true)
  getClickedValue(data, tableName)
  setSelected(data)  
 } 


  //////// function to get clicked value
const getClickedValue = async(rowData: any, tableName: string) => {
if(user?.customerName === 'PCPLCRM' && CRMStore.SubtaskGroupDetails.some((e)=> `CRM ${e.subtask}` === tableName)) CRMStore.activeRowHandler(rowData,name);
if(tableName === 'CRM Authorization' ){
  CRMStore.authorizationModel = true;
  CRMStore.subtaskCompoent.selectedRowDetails.id = rowData.id;
  CRMStore.subtaskCompoent.selectedRowDetails.title = rowData.title;
} 
if(tableName === 'CRM InWard' || tableName === 'CRM OutWard'){
  CRMStore.subtaskCompoent.selectedRowDetails.id = rowData.id;
  CRMStore.subtaskCompoent.selectedRowDetails.title = rowData.title;
  CRMStore.handleLogisticCompoentShow(
    tableName,
    rowData.id,
    CRMStore.logistictextAreaElementId
      .filter((e) => e.itemId === rowData.id && e.name === tableName.replace('CRM','').trim())[0].templateDatails
  );
}
    if (tableName === 'ReceivingTable') {
      dashboardStore.showClickedValueForReceiving(
        rowData.id,
        rowData.receivingTitle,
        rowData.barcode_Package,
        rowData.sender_Details || ''
      );
    } else if (tableName === 'OrderRegisterTable') {
      dashboardStore.dashboard.deliveryOrderTableClicked = true;
      dashboardStore.setOrderRequestDetails(rowData);
    } else if (
      tableName === 'DeliveryTableSmall' ||
      tableName === 'DeliveryTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    }  else if (
      tableName === 'HFCShipper'  && (dashboardStore.dashboard.valueForL3Orders === "Shipper" )
    ) {
      activityStore.showClickedValueForHFCShipper(rowData.id);
      // agent.HFC.HFCShippingPrepSelected(rowData.id);
    } else if (
      tableName === 'HFCShipper'  && ( dashboardStore.dashboard.valueForL3Orders === "Receiving")
    ) {
      activityStore.showClickedValueForHFCReceiving(rowData.id);
      // agent.HFC.HFCShippingPrepSelected(rowData.id);
    } else if (
      tableName === 'HFCShipper'  && ( dashboardStore.dashboard.valueForL3Orders === "Assign Task to Personnal")
    ) {
      activityStore.showClickedValueForHFCServiceAssign(rowData.id);
      // agent.HFC.HFCShippingPrepSelected(rowData.id);
    }else if (
      tableName === 'HFCShipper'  && ( dashboardStore.dashboard.valueForL3Orders === "Services")
    ) {
      await activityStore.showClickedValueForHFCCustomerrequest(rowData.id);
      try {
      SetIsModal(true);
      setTitle(rowData.title)
      setRowData(rowData);
      setSelectedId(rowData.id)
      const res = await agent.HFC.HFCServiceElements(rowData.id);
      const sortedElements = res?.data?.elements?.sort((a:any, b:any) => a.elementIndex - b.elementIndex);
      setShippingPrep({
        ...res.data,
        elements: sortedElements
      });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      // agent.HFC.HFCShippingPrepSelected(rowData.id);
    }else if (
      tableName === 'HFCShipper'  && (dashboardStore.dashboard.valueForL3Orders === "Returning Services")
    ) {
      activityStore.showClickedValueForHFCServiceReturn(rowData.id);
      // agent.HFC.HFCShippingPrepSelected(rowData.id);
    } else if (tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Shipping") {

      const res = await agent.HFC.HFCShippingPrepSelected(rowData.id);
      const sortedElements = res.data.elements.sort((a:any, b:any) => a.elementIndex - b.elementIndex);
      setShippingPrep({
        ...res.data,
        elements: sortedElements
      });
    }else if (tableName === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Shipping Prep") {
      try {
        // Open the modal
        SetIsModal(true);
        setTitle(rowData.title)
        setRowData(rowData);
        setSelectedId(rowData.id)
        const res = await agent.HFC.HFCShippingPrepSelected(rowData.id);
        const sortedElements = res.data.elements.sort((a:any, b:any) => a.elementIndex - b.elementIndex);
        setShippingPrep({
          ...res.data,
          elements: sortedElements
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    
    
    else if (
      tableName === 'OutwardsTableSmall' ||
      tableName === 'OutwardsTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (
      tableName === 'PickerAssign' ||
      tableName === 'AssignPickerOutward'
    ) {
      activityStore.outward.assignPickerDefault = {
        pickerName: '',
        pickerPhoneNumber: '',
      };
      dashboardStore.showClickedValueOutwardInward(rowData.id);
      const selectRow = tabledata?.filter(
        (eachRow: any) => eachRow.id === rowData.id,
      )?.[0];
      activityStore.outward.assignPickerDefault = {
        pickerName: selectRow.itemDeliveryRequest?.[0]?.pickerName,
        pickerPhoneNumber:
          selectRow.itemDeliveryRequest?.[0]?.pickerPhoneNumber,
      };
    } else if (tableName === 'Billing') {
      activityStore.outward.billing = {
        ...activityStore.outward.billing,
        billType: '',
        amount: '',
      };
      dashboardStore.showPaginationValueOutwardInward(pageNumData);
      dashboardStore.showClickedValueOutwardInward(rowData.id);
      const selectRow = tabledata?.filter(
        (eachRow: any) => eachRow.id === rowData.id,
      )?.[0];
      activityStore.outward.billing = {
        ...activityStore.outward.billing,
        billType: selectRow?.billType,
        amount: selectRow?.amount,
      };
    } else if (
      tableName === 'AssetTable' ||
      tableName === 'AssetTableTag' ||
      tableName === 'TagTable' ||
      tableName === 'CreateOrderTable'
    ) {
      if(tableName === 'AssetTable'){
        if(user?.customerName !== 'Mepz' && (user?.customerName !== 'PCPLCRM' && user?.roleName !== 'IT Team') && user?.customerName !== 'HFC Media Services'){
          dashboardStore.showClickedValueForAssetTable(rowData.id);
          activityStore.loadActivity(rowData.id)
        }
    }else{
      dashboardStore.showClickedValueForAssetTable(rowData.id);
      activityStore.loadActivity(rowData.id)
    }
    } else if (tableName === 'QuickScan') { 
      setTimeout(() => {
        if (
          // QuickScanStore?.QuickscancheckboxChecker[0]?.isChecked === true &&
          QuickScanStore?.QuickscanCheckboxer1 === true
        ) {
          quickScanshowButton(rowData['status']);
          QuickScanStore.QuickscanCheckboxfalse(false);
        } else {
          quickScanshowButton(rowData[' ']);
        }
      }, 100);
    } else if(tableName === 'Reel Smarttracker'){
      TrackingReportStore.resetButtons();
      const replaceName: Record<string, string> = {
        'Wave Production': 'Wave',
        'CC Form Production': 'CC',
        'QT Processes': 'QTProcess'
    };
    if (rowData['title_Status'] !== replaceName[TrackingReportStore.reelSmarttracker?.selectedSubtask]) {
      toast.error("You are not permitted to work with this reel.")
      return;
    }
      TrackingReportStore.statusButtonShow(rowData['status']);
      TrackingReportStore.reelSmarttracker.isModel  = true;
      TrackingReportStore.reelSmarttrackerComponent = {...rowData};
    }
    dashboardStore.updateRowData(rowData.id);
    setActiveRowId(rowData.id);
  };
  const ResolveModal = (actiontype: string, rowData: any) => {
    //setting the redirect reject comment false
    mediaAssetStore.mediaAsset.redirectOpenReject = false;
    // setting the AlertsModal false
    mediaAssetStore.mediaAsset.alertsResolveorRejectModalOpen = false;
    // opens resolve modal
    rejectionStore.loadRejectionById(rowData.id);
    ElementStore.setSelectedSubTask(rowData.subtask);
    mediaAssetStore.openMediaAssetResolveModal(true);

    history(`/mediaAssets/${rowData.itemID}`);
  };
  let tableheightcss =
    tableName === 'ReceivingTable' ||
    tableName === 'AssetTableTag' ||
    tableName === 'OrderRegisterTable' ||
    tableName === 'TagTable' ||
    tableName === 'CreateOrderTable' ||
    tableName === 'DeliveryTableSmall' ||
    tableName === 'InwardsTableSmall' ||
    tableName === 'OutwardsTableSmall' ||
    tableName === 'VaultTable' ||
    tableName === 'EmailTable' ||
    tableName === 'DeviceTable' ||
    tableName === 'ShelfRackTable' ||
    tableName === 'DepartmentTable' ||
    tableName === 'WorkLevelTable' ||
    tableName === 'HistoryTable' ||
    tableName === 'OrderTable' ||
    tableName === 'AlertsTable' ||
    tableName === 'ReadMail' ||
    tableName === 'UnreadMail' ||
    tableName === 'viewHistoryTable' ||
    tableName === 'viewTemplateTable';

  const classNameFunc1 = (data: string) => {
    if (
      data === 'ReportsTable' ||
      data === 'FilmFestivalReport' ||
      data === 'AllocateUser' 
    ) {
      return 'table-height-reports';
    }
    else if (CRMStore.SubtaskGroupDetails.some((e)=> `CRM ${e.subtask}` === data) || data === 'IT Asset List') {
      return 'table-height-reports2';
    } else if (data === 'QuickScan' || data === 'CrmAssetTrack') {
      return 'table-height-reports1';
    }
    else if(data === 'ReadMail' || data === 'UnreadMail'){
      return 'table-height-mail';
    } else if (tableheightcss) {
      return 'table-height'; //small table
    } else if (
      data === 'PickerAssign' ||
      data === 'AssignPickerOutward' ||
      data === 'Billing'
    ) {
      return '';
    } else {
      return 'table-height1';
    }
  };

  const classNameFunc2 = (data: string) => {
    if (
      data === 'ReportsTable' ||
      data === 'FilmFestivalReport' ||
      data === 'AllocateUser'
    ) {
      return 'dynamictableoverflow-reports';
    }
    else if (CRMStore.SubtaskGroupDetails.some((e)=> `CRM ${e.subtask}` === data)) {
      return 'dynamictableoverflow-reports2';
    }  
    else if (data === 'QuickScan' || data === 'CrmAssetTrack') {
      return 'dynamictableoverflow-reports1';
    } 
    else if (data === 'ReadMail' || data === 'UnreadMail' || data === 'IT Asset List') {
      return 'dynamictableoverflow-mail';
    }
    else if (tableheightcss) {
      return 'dynamictableoverflow';
    } else {
      return 'dynamictableoverflow1';
    }
  };

  
  // const addToItemFiles = async (blobFile: Blob, fileName: string,data:any) => {
  //   let response;
  //   let addFilesPayload: uploadFileType = { id: '', files: [] };
  //   var file = new File([blobFile], fileName);
   
  //     response = await agent.Files.uploadFile(file);
  //     addFilesPayload = {
  //       id:data.id,
  //       files: [{ ...response.data, addedOn: new Date() }],
  //     };
  //   await ElementStore.HFCgeneratePdf(addFilesPayload);
  // };

  const getVerifyStatus = (rowData: any) => {
    if (
      dashboardStore.dashboard.L2CardValueOrders === 'Outward' &&
      dashboardStore.dashboard.valueForL3Orders === 'VerifyOutward'
    ) {
      let disable = false;
      rowData?.orders.forEach((order: any) => {
        if (order.isActive) {
          disable = true;
          return disable;
        }
      });
      return disable;
    } else {
      return false;
    }
  };

  const receivedAsset = (id: string, isReceived: boolean,asset_Moved_To:string) => {
    const handleReceived = async () => {
      try {
        await agent.CRMAssetTracking.receivedCRMAsset(id, user?.customerName || '', true);
         CRMStore.handleCrmAssetSearch(dashboardStore.dashboard.searchfilterparams);
        toast.success('Asset received successfully');
      } catch (error) {
        toast.error('Error updating asset status');
      }
    };
    return user?.departmentName === asset_Moved_To && !isReceived ? (
      <Button positive onClick={handleReceived}>
        Received
      </Button>
    ) : null;
  };

  return (
   (<span className={isdisabled ? 'component-isDisabled' : ''}>
      {window.innerWidth > 768 ? (
        <Segment className={classNameFunc1(tableName)}>
          <Segment className={classNameFunc2(tableName)}>
            {dashboardStore.dashboard.reportsConfiguration === true ? (
              <ReportsModal
                toggleProps={dashboardStore.dashboard.tableconfigurationClicked}
              />
            ) : null}
           {( (loading) ? <LoadingComponent/> : <Table
              sortable
              selectable
              celled
              singleLine
              padded={
                tableheightcss ||
                tableName === 'ReportsTable' ||
                tableName === 'FilmFestivalReport'
                  ? 'very'
                  : false
              }
            >
              <Table.Header>
                <Table.Row>
                  {actiontype === 'priority' ? (
                    <Table.HeaderCell>pH Value</Table.HeaderCell>
                  ) : null}
                  
                  {tableName === 'AllocateUser' || (tableName === 'HFCScan' && (
                    <Table.HeaderCell>
                      {
                        (userLanguage[0].AllocateUser?.AUH02 as any)?.[
                          `${commonStore.language?.key}`
                        ]
                      }
                    </Table.HeaderCell>
                  ))}

                  {(tableName === 'QuickScan' || tableName === 'UnreadMail' || tableName === "NFAIRestorationDashboard") && (
                    /// search
                    <Table.HeaderCell></Table.HeaderCell>
                  )}
                  
                  {// eslint-disable-next-line
                  tableName === 'SmartTracker' && ['Operator','Quality Check'].includes(user?.roleName.trim() || '') && user?.customerName === 'NFAIReport' || tableName === 'Reel Smarttracker' ? <></> :tableName === 'CRM Table' || tableName === 'CRM Authorization' || tableName === 'CRM InWard'|| tableName === 'CRM OutWard'|| CRMStore.SubtaskGroupDetails.some((e)=> `CRM ${e.subtask}` === tableName) ||
                  tableName==="CircuitHistory" ? null :
                  tableHeads
                  ?.map((tablehead: any, index: number) => {
                    return (
                      <>
                      {(commonStore.hfcCustomerChanges && tableName==="AssetTable") ? null :
                      <>
                        {' '}
                        {
                      tableName === 'CrmAssetTrack' ? (
                        (tablehead === 'history' || tablehead === 'edit' || tablehead === 'isReceived' || CRMStore.assetTracking.deptValue !== '') ? (
                          <Table.HeaderCell></Table.HeaderCell>
                        ) : (
                          <Table.HeaderCell key={index}>
                          <SearchInputData
                            loader={!loading}
                            setPageNumber={setPageNumber}
                            tablehead={tablehead}
                            tablename={tableName}
                            index={index}
                            EmailsearchHandler={EmailsearchHandler}
                          /></Table.HeaderCell>
                        )
                      ) : (
                        <Table.HeaderCell key={index}> <SearchInputData
                          loader={!loading}
                          setPageNumber={setPageNumber}
                          tablehead={tablehead === 'Asset_id' || tablehead === 'asset_id' ? 'physical_sensor_NFC' : tablehead}
                          tablename={tableName}
                          index={index}
                          EmailsearchHandler={EmailsearchHandler}
                        /></Table.HeaderCell>
                      )
                    }
                      </>
                      }
                      </>
                    );
                  })}
                  {actiontype !== 'Resolve' &&
                  actiontype !== 'editdel' &&
                  actiontype !== '' &&
                  tableName !== 'CRM Authorization' &&
                  tableName !== 'CRM InWard'&& 
                  tableName !== 'CRM OutWard' &&
                  actiontype !== 'priority' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype === 'Resolve' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype === 'editdel' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                </Table.Row>
              </Table.Header>

              <Table.Header>
                <Table.Row>
                {tableName === 'AllocateUser' || (tableName === 'HFCScan' && (
                    <Table.HeaderCell>
                      <Checkbox
                        checked={
                          commonStore.hfcCustomerChanges ?
                            (reportStore.isCheckAll.checked)  :
                            ((reportStore.isCheckAll.checked &&
                              reportStore.isCheckAll.activePage === pageNumData) ||
                            reportStore.allocateItemToUserArray.includes(''))
                        }
                        onClick={(event: any, dataField: any) => {
                          reportStore.checkBoxCheckedAll(
                            data,
                            dataField,
                            pageNumData,
                          );
                        }}
                      />
                    </Table.HeaderCell>
                  ))}
                  {
                    tableName === "NFAIRestorationDashboard" && (
                      <Table.HeaderCell>
                        <Checkbox
                        checked={isAllSelected}
                onChange={handleSelectAll}
                        />
                      </Table.HeaderCell>
                    )
                  }

                  {(tableName === 'QuickScan' || tableName === 'UnreadMail') && (
                    /// main checkbox quickscan
                    <Table.HeaderCell>{
                      (userLanguage[0].MessagesTable.MT02 as any)?.[`${commonStore.language.key}`]
                      }</Table.HeaderCell>
                  )}

                  {actiontype === 'priority' ? (
                    <Table.HeaderCell>
                      <span className="ml-0 colorDot0"></span>
                      <span className="ml-0 colorDot1"></span>
                      <span className="ml-0 colorDot2"></span>
                      <span className="ml-0 colorDot3"></span>
                      <span className="ml-0 colorDot4"></span>
                      <span className="ml-0 colorDot5"></span>
                    </Table.HeaderCell>
                  ) : null}

                  {tableHeads?.map((tablehead: any, tableIndex: number) => {
                    return (
                      <Table.HeaderCell key={tableIndex}>
                        <SortData
                          header={
                            commonStore.hfcCustomerChanges &&
                            tablehead === 'barcode_Package'
                              ? 'print'
                              : tablehead
                          }
                          tableName={tableName}
                          pageNum={pageNumData}
                          sortHandler={sortHandler}
                        />{' '}
                      </Table.HeaderCell>
                    );
                  })}

                  {actiontype === 'Resolve' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype !== 'Resolve' &&
                  actiontype !== 'editdel' &&
                  actiontype !== '' &&
                  actiontype !== 'priority'  ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype === 'editdel' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                </Table.Row>
              </Table.Header>
              <Table.Body className="tabletexttruncate">
                {tabledata
                  // .filter(filterFunc)
                  .slice(
                    parseInt(state.currentPages, 10) *
                      parseInt(commonStore.hfcCustomerChanges ? activityStore.HfcSelectedRow : postsPerPage, 10) -
                      parseInt(commonStore.hfcCustomerChanges ? activityStore.HfcSelectedRow : postsPerPage, 10),
                    parseInt(state.currentPages, 10) *
                      parseInt(commonStore.hfcCustomerChanges ? activityStore.HfcSelectedRow : postsPerPage, 10),
                  ).length !== 0 ? (
                  tabledata
                    // .filter(filterFunc)
                    .slice(
                      parseInt(state.currentPages, 10) *
                        parseInt(commonStore.hfcCustomerChanges ? activityStore.HfcSelectedRow : postsPerPage, 10) -
                        parseInt(commonStore.hfcCustomerChanges ? activityStore.HfcSelectedRow : postsPerPage, 10),
                      parseInt(state.currentPages, 10) *
                        parseInt( commonStore.hfcCustomerChanges ? activityStore.HfcSelectedRow : postsPerPage, 10),
                    )
                    ?.map((rowData: any, index: number) => {
                      return (
                        <Table.Row
                          className={classNameForQuickScan?.(
                            WithoutbarcodeInvetoryData?.length
                              ? !WithoutbarcodeInvetoryData?.some(
                                  (item: string) => item === rowData.id,
                                )
                              : false,
                          )}
                          style={{ padding: '0px' }}
                          key={rowData['id']}
                          active={rowData['id'] === activeRowId}
                          onClick={() => getClickedValue(rowData, tableName)}
                          onMouseOver={() => setHoverRowId(rowData['id'])}
                        >
                          {
                            tableName === "NFAIRestorationDashboard" && (
                              <Table.Cell collapsing>
                                <Checkbox
                                checked={selectedItems.has(rowData.id)}
                                onChange={() => handleSelect(rowData.id, rowData.title)}
                                />
                              </Table.Cell>
                            )
                          }
                          {tableName === 'QuickScan' && (
                            <Table.Cell collapsing>
                              <Checkbox
                                name="quickscanchecked"
                                checked={WithoutbarcodeInvetoryData?.some(
                                  (item: string) => item === rowData.id,
                                )}
                                onClick={(e: any, data: any) => {
                                  QuickScanStore.QuickscanCheckboxfalse(
                                    data.checked,
                                  );
                                  checkBoxClickedInventoryandQuickScan?.(
                                    rowData,
                                    data,
                                    index,
                                    data.checked,
                                  );
                                  QuickscanAsstableClicked(
                                    rowData,
                                    data?.checked,
                                    index,
                                  );
                                }}
                              />
                            </Table.Cell>
                          )}
                          {tableName === 'AllocateUser' || (tableName === 'HFCScan' && (
                            <Table.Cell collapsing>
                              <Checkbox
                                checked={
                                  commonStore.hfcCustomerChanges ?
                                  (reportStore.HFCallocateItemToUserArray.some((item: any) => item.id === rowData.id) || reportStore.isCheckAll.checked) :
                                    (reportStore.isCheckAll.checked &&
                                      reportStore.isCheckAll.activePage === pageNumData) ||
                                    reportStore.allocateItemToUserArray.includes(rowData.id)
                                }
                                onClick={() => {

                                  if (tableName !== 'HFCScan') {
                                    // Only allow onClick when tableName is not 'HFCScan'
                                    reportStore.AllocateUserData(data, rowData, pageNumData);
                                  }
                                  else{
                                    reportStore.HFCCheckboxHandler(rowData)
                                  }
                                }}
                              />
                            </Table.Cell>
                          ))}
                          { tableName === 'UnreadMail' && 
                            <Table.Cell collapsing>
                            <Checkbox  onClick={() => {ReadMailCheckboxFunc(rowData?.id,rowData?.subject)}}/>
                            </Table.Cell>
                          }
                          {actiontype === 'priority' ? (
                            <Table.Cell collapsing>
                              {/* <> */}
                              <span
                                className={
                                  rowData.calculated_category === 0
                                    ? 'colorDot0'
                                    : rowData.calculated_category === 1
                                      ? 'colorDot1'
                                      : rowData.calculated_category === 2
                                        ? 'colorDot2'
                                        : rowData.calculated_category === 3
                                          ? 'colorDot3'
                                          : rowData.calculated_category === 4
                                            ? 'colorDot4'
                                            : 'colorDot5'
                                }
                              ></span>
                              {/* </> */}
                            </Table.Cell>
                          ) : null}
                          {tableName === 'AssetTable' ||
                          tableName === 'TagTable' ||
                          tableName === 'CreateOrderTable' ||
                          tableName === 'QuickScan' ||
                          Object.keys(tabledata[0]).includes('title') ? (
                            <Table.Cell key={rowData['id']}>
                              {(tableName !== 'WorkLevelTable' && tableName !== 'HFCShipperMovement' && tableName !== 'HFCShipper' && tableName !== 'CrmAssetTrack'  )? (
                                <Link to={`/mediaAssets/${rowData['id']}`}>
                                  {rowData['title']} 
                                </Link>
                              ) : (
                                rowData['title']
                              )}
                            </Table.Cell>
                          ) : null}
                          {tableHeads?.map((i: any, tInd: number) => {
                            return i !== 'id' ? (
                              i.toLowerCase() !== 'title' &&
                              i.toLowerCase() !== 'parent' ? (
                                <React.Fragment key={tInd}>
                                  {user?.customerName === 'LVP CMS - AM' ? (
                                    <>
                                      {i.toLowerCase() ===
                                        'physical_location_vault' ||
                                      i.toLowerCase() === 'asset_In_Vault' ? (
                                        <></>
                                      ) : i.toLowerCase() ===
                                        'physical_location_room' ? (
                                        <Table.Cell key={i}>
                                          {rowData[`physical_location_vault`]}
                                        </Table.Cell>
                                      ) : i.toLowerCase() ===
                                        'asset_in_room' ? (
                                        <Table.Cell key={i}>
                                          {rowData[`asset_In_Vault`]}
                                        </Table.Cell>
                                      ) : (
                                        <Table.Cell key={i}>
                                          {rowData[i]?.replaceAll('<br/>', '')}
                                        </Table.Cell>
                                      )}
                                    </>
                                  ) : i.includes('Asset_id') ? (
                                    <Table.Cell key={'Asset_id'}>
                                      {rowData[
                                        'physical_sensor_NFC'
                                      ]?.replaceAll('<br/>', '')}
                                    </Table.Cell>
                                  ) : i.toLowerCase() === 'history' 
                                  ? <Table.Cell key={i} ><Button onClick={()=> {
                                    CRMStore.assetTracking.isHistory = true
                                    CRMStore.assetTracking.selectedId = rowData.id}}>View
                                    </Button></Table.Cell> :
                                  i.toLowerCase() === 'edit' ? 
                                  <Table.Cell key={i}><Button primary onClick={()=>{
                                    CRMStore.assetTracking.isField = 'Edit';
                                    CRMStore.assetTracking.SelectedRowFormData = rowData;
                                  }}>Edit</Button></Table.Cell> :
                                  i.toLowerCase() === 'isreceived' ? 
                                  <Table.Cell key={i}>{receivedAsset(rowData.id,rowData.isReceived,rowData.asset_Moved_To)}</Table.Cell> :
                                  (
                                    <Table.Cell key={i}>
                                      {rowData[i]?.toString()?.replaceAll('<br/>','')}
                                    </Table.Cell>
                                  )}
                                </React.Fragment>
                              ) : i.toLowerCase() === 'parent' ? (
                                <Table.Cell key={i}>
                                  <Link
                                    to={`/mediaAssets/${rowData[
                                      'parent'
                                    ]?.split('/')[0]}`}
                                  >
                                    {rowData['parent']?.split('/')[1]}
                                  </Link>
                                </Table.Cell>
                              ) : null
                            ) : null;
                          })}
                        {
                            actiontype === "acc/rej" ?(
                              <Table.Cell collapsing>
                                 <Button.Group compact size="tiny">
                                  <Button positive onClick= {()=>handleApprove(rowData['id'], rowData)}>Accept</Button>
                                  <Button.Or />
                                  <Button onClick= {()=>handleReject(rowData['id'])}>Reject</Button>
                                </Button.Group>
                              </Table.Cell>
                            ):null
                          }
                          
                          {actiontype !== 'editdel' &&
                          actiontype !== 'Resolve' &&
                          actiontype !== 'priority' &&
                          actiontype !== 'acc/rej' &&
                          actiontype !=='del' && 
                          actiontype !== 'Invoice' &&
                          actiontype !== 'editdel' &&
                          actiontype !== 'Resolve' &&
                          actiontype !== 'priority' &&
                          !tableName.includes('CRM') &&
                          actiontype.length > 0 ? (
                            <Table.Cell collapsing>
                              {rowData['id'] === hoverRowId ? (
                                <Button.Group compact size="tiny">
                                  <Button
                                    positive
                                    onClick={() =>
                                      dashboardStore.DenialModalOpen(
                                        true,
                                        actiontype.split('|')[0],
                                        true,
                                        rowData.id,
                                      )
                                    }
                                    disabled={getVerifyStatus(rowData)}
                                  >
                                    {actiontype.split('|')[0]}
                                  </Button>

                                  {actiontype.split('|')[1] && (
                                    <>
                                      <Button.Or />
                                      <Button
                                        onClick={() =>
                                          dashboardStore.DenialModalOpen(
                                            true,
                                            actiontype.split('|')[1],
                                            false,
                                            rowData.id,
                                          )
                                        }
                                        size="tiny"
                                        disabled={getVerifyStatus(rowData)}
                                      >
                                        {actiontype.split('|')[1]}
                                      </Button>
                                    </>
                                  )}
                                </Button.Group>
                              ) : null}
                            </Table.Cell>
                          ) : null}
                          {actiontype === 'Resolve' ? (
                            <Table.Cell collapsing>
                              {rowData['resolveMessage']?.length !== 0 ? (
                                <>
                                  {rowData['id'] === hoverRowId ? (
                                    <Button size="tiny" disabled>
                                      {actiontype}
                                    </Button>
                                  ) : null}
                                </>
                              ) : (
                                <>
                                  {rowData['id'] === hoverRowId ? (
                                    <Button
                                      disabled={
                                        !dashboardStore.dashboard.selectedUserRoleId.includes(
                                          'SB04',
                                        )
                                          ? true
                                          : false
                                      }
                                      positive
                                      onClick={() =>
                                        ResolveModal(actiontype, rowData)
                                      }
                                      size="tiny"
                                    >
                                      {actiontype}
                                    </Button>
                                  ) : null}
                                </>
                              )}
                            </Table.Cell>
                          ) : null}
                          {
                            actiontype === 'del' ?
                            <Table.Cell collapsing>
                              <Icon
                              name='delete'
                              onClick={() => deleteData(rowData, tableName)}
                              />
                            </Table.Cell> : null
                          }
                          {/* {
                            actiontype === 'Invoice' ?
                            <Table.Cell collapsing>
                            <PDFDownloadLink 
                              document={<ShippingReceipt data={rowData} />} 
                              fileName="ShippingReceipt.pdf"
                            >
                              {({ blob, url, loading, error }) => (
                                <Button 
                                  color="green" 
                                  icon 
                                  labelPosition="left" 
                                  // onClick={() => invoice(rowData, tableName)} 
                                  disabled={printLoading}                    
                                  onClick={() => addToItemFiles(blob!, 'ShippingReceipt.pdf', rowData)}
                                >
                                  {printLoading && <Loader active inline size="tiny" />}
                                  <Icon name="print" />
                                  Print Receipt
                                </Button>
                              )}
                            </PDFDownloadLink>
                          </Table.Cell> : null
                          } */}
                           {
                            actiontype === 'Invoice' ?
                            <Table.Cell collapsing>
                            <Button  color= "green" icon labelPosition='left' onClick={()=>openpdfModal(rowData)}>
                              <Icon name='print' />
                              Print Receipt
                            </Button>
                            <Button  color= "yellow" icon labelPosition='left' onClick={()=>openLabelModal(rowData, tableName)}>
                              <Icon name='file alternate outline' />
                              Generate Fedex Bill
                            </Button>
                          </Table.Cell> : null
                          }

                          {actiontype === 'editdel' ? ( 
                            <Table.Cell collapsing>
                              {rowData['id'] === hoverRowId ? (
                                <>
                                  {commonStore.filterModeTwo.includes(
                                    'AVIB02',
                                  ) ? (
                                    <></>
                                  ) : (
                                    <Icon
                                      name="edit"
                                      disabled={
                                        tableName === 'WorkLevelTable' &&
                                        commonStore.filterModeZero?.includes(
                                          'AVIB02',
                                        )
                                      }
                                      // disabled={
                                      //   tableName === 'VaultTable' &&
                                      //   !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //     'VMVVB02',
                                      //   )
                                      //     ? true
                                      //     : tableName === 'DeviceTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'DMVDB02',
                                      //       )
                                      //     ? true
                                      //     : tableName === 'ShelfRackTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'SRMVB02',
                                      //       )
                                      //     ? true
                                      //     : tableName === 'DepartmentTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'DMVB02',
                                      //       )
                                      //     ? true
                                      //     : tableName === 'CustomerTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'CMVB02',
                                      //       )
                                      //     ? true
                                      //     : tableName === 'WorkLevelTable' &&
                                      //       commonStore.filterModeOne?.includes(
                                      //         'AVIB02',
                                      //       )}
                                      onClick={() => loadEditData(rowData.id)}
                                    />
                                  )}
                                  {commonStore.filterModeTwo.includes(
                                    'AVIB03',
                                  ) ? (
                                    <></>
                                  ) : (
                                    <Icon
                                      disabled={
                                        tableName === 'WorkLevelTable' &&
                                        commonStore.filterModeZero?.includes(
                                          'AVIB03',
                                        )
                                      }
                                      // disabled={
                                      //   tableName === 'VaultTable' &&
                                      //   !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //     'VMVVB03',
                                      //   )
                                      //     ? true
                                      //     : tableName === 'DeviceTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'DMVDB03',
                                      //       )
                                      //     ? true
                                      //     : tableName === 'ShelfRackTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'SRMVB03',
                                      //       )
                                      //     ? true
                                      //     : tableName === 'DepartmentTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'DMVB03',
                                      //       )
                                      //     ? true
                                      //     : tableName === 'CustomerTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'CMVB03',
                                      //       )
                                      //     ? true
                                      //     : tableName === 'WorkLevelTable' &&
                                      //       !dashboardStore.dashboard.selectedUserRoleId.includes(
                                      //         'AVIB03',
                                      //       )
                                      //     ? true
                                      //     : false
                                      // }
                                      name="delete"
                                      onClick={() =>
                                        deleteData(rowData, tableName)
                                      }
                                    />
                                  )}
                                </>
                              ) : null}
                            </Table.Cell>
                          ) : null}
                        </Table.Row>
                      );
                    })
                ) : (
                  <Table.Row
                    style={{
                      height: '20vh',
                      overflow: 'hidden',
                    }}
                  >
                    <Table.Cell
                      colSpan={
                        data.length > 0 ? Object.keys(data[0]).length : 9
                      }
                      collapsing
                    >
                      <p className="tableEmptyData">{tableName === 'Reel Smarttracker' && TrackingReportStore.titleCode.value === '' ? 'Please select the title code' : 'Sorry, no data to show'}</p>
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>)}
          </Segment>
          <Segment raised attached="top">
            <div className="dynamicTableFooter">
              {(loading) || (dashboardStore.dashboard.loadingCount) ? (
                <div>
                  {tableName === 'Reel Smarttracker' ? <Loader active inline content='loading' style={{marginLeft:'15px'}}/> :
                  <LoadingComponent3 />}
                </div>
              ) : (
               <div> <Pagination
                  // defaultActivePage={pageNumData || 1}
                  activePage={pageNumData || 1}
                  totalPages={Math.ceil(countData / (commonStore.hfcCustomerChanges ? activityStore.HfcSelectedRow : postsPerPage)) || 1}
                  onPageChange={(event, data) => pageFunc(data.activePage || 1,name)}
                /> {name === "NFAIRestorationDashboard" ? <span style={{ fontWeight: "bold"}}>FilteredCount: {metaDataStore.NfaiRestorationDashboardInfo.data.length}</span> : ""}
                {tableName === 'AssetTable' || name === 'IT Asset List'
                 ? <label style={{fontSize:'18px',fontWeight:'bold',marginLeft:'10px'}}>Total Count : {dashboardStore.dashboard.inventoryCount2}</label> : null}
                </div>
              )}
              <div
                className={
                  dashboardStore.dashboard.loadingCount
                    ? 'dynamictaleCSValign'
                    : ''
                }
              >
                {commonStore.hfcCustomerChanges && tableName === "HFCScan" && (reportStore.HFCallocateItemToUserArray.length>0) &&(<Button color="teal" onClick={openTagModal}>Move To Vault</Button>)}
                {// eslint-disable-next-line
                user?.customerName !== 'PCPLIT' && ( tableName === 'SmartTracker' && ['Operator','Quality Check'].includes(user?.roleName.trim() || '') && user?.customerName === 'NFAIReport'
               // eslint-disable-next-line
                || tableName === 'Reel Smarttracker' ? // eslint-disable-next-line 
                  <></> :
                  <>
                  {commonStore.hfcCustomerChanges && tableName === "AssetTable" && (
                    <div style={{ display: 'flex', alignItems: 'center', width: '150px' }}>
                      <div  style={{marginRight: '5px', fontWeight:"bold"}}>No Of Rows:</div>
                      <Dropdown  
                      fluid
                      selection
                      style={{width:"60px"}}
                      options={rowsOption}
                      value={activityStore.HfcSelectedRow} 
                      onChange={handlePostPerPage}/>
                    </div>
                  )}
              {selectedItems.size > 0 && (
                <Button 
                  color="teal" 
                  onClick={() => setLtoModal(true)}
                >
                  Generate LTO Label
                </Button>
              )}
              {tableName === 'CrmAssetTrack' ? null : <><DynamicTableCSVReport
                  tableData={tabledata}
                  tableName={tableName}
                />
                <div>
                  {tableName !== 'WorkLevelTable' ? (
                    <Icon
                      // onClick={() => dashboardStore.reportsConfigurationOpen(true)}
                      onClick={handleChange}
                      corner="bottom right"
                      size="large"
                      circular
                      inverted
                      color="teal"
                      name="settings"
                    />
                  ) : null}
                </div></>}</>)
          }
              </div>
            </div>
          </Segment>
        </Segment>
      ) : (
        //  <Segment className={tableName === "ReportsTable"?"table-height-reports":"table-height"}>
        <>
          <Segment
            basic
            className={
              tableName === 'ReportsTable' || tableName === 'FilmFestivalReport'
                ? 'dynamictableoverflow-reports'
                : 'dynamictableoverflow-mobile'
            }
          >
            {/* <Segment basic className="dynamictableoverflow-mobile"> */}

            {dashboardStore.dashboard.reportsConfiguration === true ? (
              <ReportsModal
                toggleProps={dashboardStore.dashboard.tableconfigurationClicked}
              />
            ) : null}

            <Table sortable selectable celled singleLine padded="very">
              <Table.Header>
                <Table.Row>
                  {actiontype === 'priority' ? (
                    <Table.HeaderCell>pH Value</Table.HeaderCell>
                  ) : null}
                  {tableHeads?.map((tablehead: any, index: number) => {
                    return (
                      <Table.HeaderCell key={index}>
                        {' '}
                        <SearchInputData
                          loader={!loading}
                          setPageNumber={setPageNumber}
                          tablehead={tablehead}
                          tablename={tableName}
                          index={index}
                        />{' '}
                      </Table.HeaderCell>
                    );
                  })}

                  {actiontype !== 'Resolve' &&
                  actiontype !== 'editdel' &&
                  actiontype !== '' &&
                  actiontype !== 'priority' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype === 'Resolve' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype === 'editdel' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                </Table.Row>
              </Table.Header>

              <Table.Header>
                <Table.Row>
                  {actiontype === 'priority' ? (
                    <Table.HeaderCell>
                      <span className="ml-0 colorDot0"></span>
                      <span className="ml-0 colorDot1"></span>
                      <span className="ml-0 colorDot2"></span>
                      <span className="ml-0 colorDot3"></span>
                      <span className="ml-0 colorDot4"></span>
                      <span className="ml-0 colorDot5"></span>
                    </Table.HeaderCell>
                  ) : null}

                  {tableHeads?.map((tablehead: any, tIndex: number) => {
                    return (
                      <Table.HeaderCell key={tIndex}>
                        {' '}
                        <SortData
                          header={tablehead}
                          tableName={tableName}
                          pageNum={pageNumData} sortHandler={()=>{}} />{' '}
                      </Table.HeaderCell>
                    );
                  })}

                  {actiontype === 'Resolve' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype !== 'Resolve' &&
                  actiontype !== 'editdel' &&
                  actiontype !== '' &&
                  actiontype !== 'priority' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                  {actiontype === 'editdel' ? (
                    <Table.HeaderCell></Table.HeaderCell>
                  ) : null}
                </Table.Row>
              </Table.Header>
              <Table.Body className="tabletexttruncate">
                {tabledata
                  // .filter(filterFunc)
                  .slice(
                    parseInt(state.currentPages, 10) *
                      parseInt(postsPerPage, 10) -
                      parseInt(postsPerPage, 10),
                    parseInt(state.currentPages, 10) *
                      parseInt(postsPerPage, 10),
                  ).length !== 0 ? (
                  tabledata
                    // .filter(filterFunc)
                    .slice(
                      parseInt(state.currentPages, 10) *
                        parseInt(postsPerPage, 10) -
                        parseInt(postsPerPage, 10),
                      parseInt(state.currentPages, 10) *
                        parseInt(postsPerPage, 10),
                    )
                    ?.map((rowData: any) => {
                      return (
                        <Table.Row
                          key={rowData['id']}
                          active={rowData['id'] === activeRowId}
                          onClick={() => getClickedValue(rowData, tableName)}
                          onMouseOver={() => setHoverRowId(rowData['id'])}
                        >
                          {actiontype === 'priority' ? (
                            <Table.Cell collapsing>
                              {/* <> */}
                              <span
                                className={
                                  rowData.calculated_category === 0
                                    ? 'colorDot0'
                                    : rowData.calculated_category === 1
                                      ? 'colorDot1'
                                      : rowData.calculated_category === 2
                                        ? 'colorDot2'
                                        : rowData.calculated_category === 3
                                          ? 'colorDot3'
                                          : rowData.calculated_category === 4
                                            ? 'colorDot4'
                                            : 'colorDot5'
                                }
                              ></span>
                              {/* </> */}
                            </Table.Cell>
                          ) : null}
                          {tableName === 'AssetTable' ||
                          tableName === 'TagTable' ||
                          tableName === 'CreateOrderTable' ||
                          tableName === 'QuickScan' ||
                          Object.keys(tabledata[0]).includes('title') ? (
                            <Table.Cell key={rowData['id']}>
                              {tableName !== 'WorkLevelTable' && tableName !== 'CrmAssetTrack'? (
                                <Link to={`/mediaAssets/${rowData['id']}`}>
                                  {rowData['title']}
                                </Link>
                              ) : (
                                rowData['title']
                              )}
                            </Table.Cell>
                          ) : null}
                          {tableHeads?.map((i: any, tIndex: number) => {
                            return i !== 'id' && i !== '' ? (
                              i.toLowerCase() !== 'title' ? (
                                <React.Fragment key={tIndex}>
                                  {user?.customerName === 'LVP CMS - AM' ? (
                                    <>
                                      {i.toLowerCase() ===
                                        'physical_location_vault' ||
                                      i.toLowerCase() === 'asset_In_Vault' ? (
                                        <></>
                                      ) : i.toLowerCase() ===
                                        'physical_location_room' ? (
                                        <Table.Cell key={i}>
                                          {rowData[`physical_location_vault`]}
                                        </Table.Cell>
                                      ) : i.toLowerCase() ===
                                        'asset_in_room' ? (
                                        <Table.Cell key={i}>
                                          {rowData[`asset_In_Vault`]}
                                        </Table.Cell>
                                      ) : (
                                        <Table.Cell key={i}>
                                          {rowData[i]}
                                        </Table.Cell>
                                      )}
                                    </>
                                  ) : (
                                    <Table.Cell key={i}>
                                      {rowData[i]}
                                    </Table.Cell>
                                  )}
                                </React.Fragment>
                              ) : null
                            ) : null;
                          })}
                          {actiontype === 'button' ? (
                            <Table.Cell collapsing>
                              {rowData['id'] === hoverRowId ? (
                                <Button.Group compact size="tiny">
                                  <Button positive>Approve</Button>
                                  <Button.Or />
                                  <Button>Deny</Button>
                                </Button.Group>
                              ) : null}
                            </Table.Cell>
                          ) : null}
                          {actiontype !== 'editdel' &&
                          actiontype !== 'Resolve' &&
                          actiontype !== 'priority' &&
                          actiontype.length > 0 ? (
                            <Table.Cell collapsing>
                              {rowData['id'] === hoverRowId ? (
                                <Button.Group compact size="tiny">
                                  <Button
                                    positive
                                    onClick={() =>
                                      dashboardStore.DenialModalOpen(
                                        true,
                                        actiontype.split('|')[0],
                                        true,
                                        rowData.id,
                                      )
                                    }
                                  >
                                    {actiontype.split('|')[0]}
                                  </Button>

                                  {actiontype.split('|')[1] && (
                                    <>
                                      <Button.Or />
                                      <Button
                                        onClick={() =>
                                          dashboardStore.DenialModalOpen(
                                            true,
                                            actiontype.split('|')[1],
                                            false,
                                            rowData.id,
                                          )
                                        }
                                        size="tiny"
                                      >
                                        {actiontype.split('|')[1]}
                                      </Button>
                                    </>
                                  )}
                                </Button.Group>
                              ) : null}
                            </Table.Cell>
                          ) : null}
                          {actiontype === 'Resolve' ? (
                            <Table.Cell collapsing>
                              {rowData['resolveMessage'].length !== 0 ? (
                                <>
                                  {rowData['id'] === hoverRowId ? (
                                    <Button size="tiny" disabled>
                                      {actiontype}
                                    </Button>
                                  ) : null}
                                </>
                              ) : (
                                <>
                                  {rowData['id'] === hoverRowId ? (
                                    <Button
                                      disabled={
                                        !dashboardStore.dashboard.selectedUserRoleId.includes(
                                          'SB04',
                                        )
                                          ? true
                                          : false
                                      }
                                      positive
                                      onClick={() =>
                                        ResolveModal(actiontype, rowData)
                                      }
                                      size="tiny"
                                    >
                                      {actiontype}
                                    </Button>
                                  ) : null}
                                </>
                              )}
                            </Table.Cell>
                          ) : null}

                          {actiontype === 'editdel' ? (
                            <Table.Cell collapsing>
                              {rowData['id'] === hoverRowId ? (
                                <>
                                  <Icon
                                    name="edit"
                                    disabled={
                                      tableName === 'VaultTable' &&
                                      !dashboardStore.dashboard.selectedUserRoleId.includes(
                                        'VMVVB02',
                                      )
                                        ? true
                                        : tableName === 'DeviceTable' &&
                                            !dashboardStore.dashboard.selectedUserRoleId.includes(
                                              'DMVDB02',
                                            )
                                          ? true
                                          : tableName === 'ShelfRackTable' &&
                                              !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                'SRMVB02',
                                              )
                                            ? true
                                            : tableName === 'DepartmentTable' &&
                                                !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                  'DMVB02',
                                                )
                                              ? true
                                              : tableName === 'CustomerTable' &&
                                                  !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                    'CMVB02',
                                                  )
                                                ? true
                                                : tableName ===
                                                      'WorkLevelTable' &&
                                                    !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                      'AVIB02',
                                                    )
                                                  ? true
                                                  : false
                                    }
                                    onClick={() => loadEditData(rowData.id)}
                                  />
                                  <Icon
                                    disabled={
                                      tableName === 'VaultTable' &&
                                      !dashboardStore.dashboard.selectedUserRoleId.includes(
                                        'VMVVB03',
                                      )
                                        ? true
                                        : tableName === 'DeviceTable' &&
                                            !dashboardStore.dashboard.selectedUserRoleId.includes(
                                              'DMVDB03',
                                            )
                                          ? true
                                          : tableName === 'ShelfRackTable' &&
                                              !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                'SRMVB03',
                                              )
                                            ? true
                                            : tableName === 'DepartmentTable' &&
                                                !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                  'DMVB03',
                                                )
                                              ? true
                                              : tableName === 'CustomerTable' &&
                                                  !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                    'CMVB03',
                                                  )
                                                ? true
                                                : tableName ===
                                                      'WorkLevelTable' &&
                                                    !dashboardStore.dashboard.selectedUserRoleId.includes(
                                                      'AVIB03',
                                                    )
                                                  ? true
                                                  : false
                                    }
                                    name="delete"
                                    onClick={() =>
                                      deleteData(rowData, tableName)
                                    }
                                  />
                                </>
                              ) : null}
                            </Table.Cell>
                          ) : null}
                        </Table.Row>
                      );
                    })
                ) : (
                  <Table.Row
                    style={{
                      height: '20vh',
                      overflow: 'hidden',
                    }}
                  >
                    <Table.Cell
                      colSpan={
                        data.length > 0 ? Object.keys(data[0]).length : 9
                      }
                      collapsing
                    >
                      <p className="tableEmptyData">Sorry, no data to show</p>
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>

            {/* </Segment> */}
          </Segment>
          <div className="dynamicTableFooter">
            {dashboardStore.dashboard.loadingCount ? (
              <LoadingComponent3 />
            ) : (
              <Pagination
                activePage={pageNumData || 1}
                firstItem={null}
                lastItem={null}
                pointing
                secondary
                totalPages={Math.ceil(countData / postsPerPage) || 1}
                onPageChange={(event, data) => pageFunc(data.activePage || 1,name)}
              />
            )}
            <div>
              <DynamicTableCSVReport
                tableData={tabledata}
                tableName={tableName}
              />
              <div>
                <Icon
                  onClick={handleChange}
                  corner="bottom right"
                  size="large"
                  circular
                  inverted
                  color="teal"
                  name="settings"
                />
              </div>
            </div>
          </div>
        </>
      )}
      {
  tableName === "HFCShipper" && dashboardStore.dashboard.valueForL3Orders === "Shipping Prep" && (
    <HFCTaskModal isModal={isModal} setIsModal={SetIsModal} rowData={rowData} shippingPrep={shippingPrep} title={title} selectedId={selectedId} setShippingPrep={setShippingPrep}/>
  )
}
{
  tableName === "HFCShipper" && dashboardStore.dashboard.valueForL3Orders === "Services" && (
    <HFCTaskModal isModal={isModal} setIsModal={SetIsModal} rowData={rowData} shippingPrep={shippingPrep} title={title} selectedId={selectedId} setShippingPrep={setShippingPrep}/>
  )
}
{
  tableName === "HFCShipper" && dashboardStore.dashboard.valueForL3Orders === "Shipping" && 
  (<ReceiptModal isModal={isModal} setIsModal={SetIsModal} data={selected}/>)
}
{
  openModal ? <LabelModal openModal={openModal} setOpenModal={setOpenModal} shippingPrep={shippingPrep} data={selected}/>: null
}
{
  ltoModal ?
    <LtoLabelModal open={ltoModal} setOpen={setLtoModal} selectedItems={selectedItems} setSelectedItems={setSelectedItems} />
: null
}
    </span>)
  );
}
export default observer(DynamicTableComponent);
